/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vtp_Shipments_Status_Awaiting_PickupInputs */

const vi_vtp_shipments_status_awaiting_pickup = /** @type {(inputs: Vtp_Shipments_Status_Awaiting_PickupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ lấy hàng`)
};

/**

* @param {Vtp_Shipments_Status_Awaiting_PickupInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vtp_shipments_status_awaiting_pickup = /** @type {((inputs?: Vtp_Shipments_Status_Awaiting_PickupInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vtp_Shipments_Status_Awaiting_PickupInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vtp_shipments_status_awaiting_pickup(inputs)
});